import { prefStorage } from '@samknows/utils';
import { Grants, GRANT_SECTION } from '@/common/services/account/types';

export function hasPermissions(
  type: string | GRANT_SECTION,
  permission?: string,
  query?: Record<string, unknown> | string
): boolean {
  const grantTree: Grants = prefStorage.get('grants');

  if (!grantTree) {
    return false;
  }

  if (!grantTree[type]) {
    return false;
  }

  const grants = grantTree[type][permission];

  if (!grants) {
    return false;
  }

  if (!query) {
    return true;
  }

  // Support the old syntax still
  const queryObject = typeof query === 'string' ? { [query]: true } : query;

  return grants.some((restriction: Record<string, unknown>) =>
    Object.keys(query).every((key) => queryObject[key] === restriction[key])
  );
}
